import type { MyPermissions } from "@/entities/permission/api/permissionService";

/**
 * 1002(老板拍板):客服舱没开着(暂停 / 过期 / 未拥有)但在 historyModules 里 → 客服页进「只读 + 人工处理」模式:
 * 只留会话列表 / 详情 / 历史消息 + 人工回复 / 结束;AI 相关入口(统计、场景偏好、知识优化、接管)隐藏。
 * 后端是唯一真源:历史上没拥有过客服舱的租户,人工处理口子同样 403(reason=NOT_OWNED),页面据此转去「未开通」。
 */
export function kefuHumanOnly(permissions: MyPermissions | null | undefined): boolean {
  if (!permissions) return false;
  const mod = permissions.modules?.["ai_kefu"];
  const on = !!mod && mod.page !== "none";
  // 后端给了 everOwnedModules 就以它为准(从没拥有过的直接不进);老后端无该字段时回落 historyModules,由后端 403 兜底
  const pool = permissions.everOwnedModules ?? permissions.historyModules ?? [];
  return !on && pool.includes("ai_kefu");
}
